/*
 * Regras puras do PainelDividido (sem React): a largura do painel da esquerda é
 * um percentual do contêiner, limitado pelos mínimos em px de cada lado.
 */

export const PASSO_TECLADO = 2;

const arredondar = valor => Math.round(valor * 10) / 10;

/*
 * Mantém o percentual entre os mínimos em px dos dois painéis. Sem largura
 * conhecida (contêiner ainda não medido), só limita a 0..100.
 */
export const limitarPercentual = (percentual, larguraTotal, {minimoEsquerda = 0, minimoDireita = 0} = {}) => {
    const valor = Number.isFinite(percentual) ? percentual : 0;
    if (!larguraTotal || larguraTotal <= 0) {
        return arredondar(Math.min(Math.max(valor, 0), 100));
    }

    const minimo = (minimoEsquerda / larguraTotal) * 100;
    const maximo = 100 - (minimoDireita / larguraTotal) * 100;
    // Contêiner menor que a soma dos mínimos: divide ao meio.
    if (minimo > maximo) {
        return 50;
    }

    return arredondar(Math.min(Math.max(valor, minimo), maximo));
};

/* Percentual correspondente à posição do ponteiro dentro do contêiner. */
export const percentualDoPonteiro = (clientX, {left = 0, width = 0} = {}, limites) => {
    if (!width) {
        return limitarPercentual(0, 0, limites);
    }

    return limitarPercentual(((clientX - left) / width) * 100, width, limites);
};

/* Valor gravado no navegador -> percentual válido, ou o padrão quando ausente ou corrompido. */
export const lerPercentualSalvo = (texto, padrao) => {
    if (texto === null || texto === undefined || String(texto).trim() === '') {
        return padrao;
    }

    const valor = Number(texto);
    return Number.isFinite(valor) && valor > 0 && valor < 100 ? valor : padrao;
};
